import { errorToast } from '@/shared/services/helper.js'
import logoutCleanup from './logoutCleanup';
export default function handlerErrorFromApis(error) {
    const status = error?.response?.status;
    if(!error?.response) {
        return Promise.reject([`${status ? status : `C ${error?.response}`} Error: Check your NETWORK agian and refresh the page.`]);
    };
    switch (status) {
        case 422:
            if (error.response.data.details) {
                return Promise.reject(`Error ${status}: ${error?.response?.data?.details?.[Object.keys(error?.response?.data?.details)?.[0]]}`);
            } else {
                return Promise.reject([`Error ${status}: ${error?.response?.data?.errors ?? error?.response?.data?.message}`]);
            }
        case 401:
            errorToast('You Have Been Logged Out From This Device.');
            clearDataOnUnauthorised();
            break;
        case 400:
        case 498:
        case 500:
            return Promise.reject([`Error ${status}: ${error?.response?.data?.error || error?.response?.data?.errors || error?.response?.data?.message}`]);
        default:
            return Promise.reject([`Error ${status}: Refresh the page and try again.`]);
    }
}
 
async function clearDataOnUnauthorised() {
    window.cookies.keys().forEach(cookie => window.cookies.remove(cookie))
    window.store.dispatch('resetAllState');
    await logoutCleanup()
    window.router.push({name:'Home'});
}